<div class="card">
  <div class="card-header d-flex justify-content-between align-items-start">
    <h4>{{ 'MENU.LAST_PROPOSED' | translate }}</h4>
    <a routerLink="/dashboard/requests-eligible-candidate-list">{{ 'VIEW_ALL'|translate }}</a>
  </div>
  <div class="card-body">
    <div *ngIf="candidateProposedList?.length < 1">{{ 'ALERT.ERROR_NOT_FOUND_PROPOSED_CANDIDATE' | translate }}</div>
    <div *ngFor="let candidate of candidateProposedList" class="row mb-1">
      <div class="col-12">
        <a [routerLink]="candidate.user.type_code === 'candidate' ? ('/dashboard/candidate/edit/'+candidate.user.hash) : ('/dashboard/user/profile/'+candidate.user.hash) ">{{ candidate.user.complete_name }}</a>
        <!--stato-->
        <span class="badge badge-{{candidate.color_step}} ml-05">{{ candidate.label_step | translate }}</span>
        <div class="d-flex justify-content-between font-small-2 mt-025">
          <!--Richiesta-->
          <a class="font-weight-medium text-break-line-1 mb-0" [routerLink]="'/dashboard/detail-request/' + candidate.request_id">{{ candidate.request_name }}</a>
          <span>{{ candidate.data.insert_date | date: 'dd/MM/yyyy' }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
